<template>
  <div>
    <b-row>
      <b-col
        md="3"
        sm="12"
      >
        <b-card>
          <div>
            <h3>{{ fullName }}</h3>
          </div>
          <hr>
          <h3 class="mb-0">
            Folio: {{ data.solicitud.folio }}
          </h3>
          <span class="card-text">
            Fecha de registro: {{ registerDate }}
          </span>
          <div class="mt-75">
            <b-badge
              variant="primary"
              class="ml-0 mb-1"
            >
              {{ data.solicitud.tipo_convocatoria.nombre }}
            </b-badge>
            <b-badge
              :variant="statusVariant(data.solicitud.estatus_solicitud.id)"
              class="ml-0 mb-75"
            >
              {{ data.solicitud.estatus_solicitud.descripcion }}
            </b-badge>
          </div>
        </b-card>
        <b-card>
          <empleado
            :id="data.id"
            :data="data.datosempleado"
            :is-required="data.solicitud.tipo_convocatoria.datos_empleado"
          />
        </b-card>
      </b-col>
      <b-col
        md="9"
        sm="12"
      >
        <titulo-section
          v-if="data.solicitud.detalles"
          :text="data.solicitud.detalles"
          :icon="statusVariantIcon(data.solicitud.estatus_solicitud.id)"
          :color="
            statusVariantDetalles(data.solicitud.estatus_solicitud.id)
          "
          class="mb-1"
        />
        <b-row>
          <b-col cols="12">
            <b-card>
              <datos-personales
                :id="data.id"
                :data="data"
              />
            </b-card>
          </b-col>
          <b-col cols="12">
            <b-card>
              <contacto
                :id="data.id"
                :data="data.contacto"
              />
            </b-card>
          </b-col>
          <b-col
            v-if="data.estudios"
            cols="12"
          >
            <b-card>
              <estudios
                :id="data.id"
                :data="data.estudios"
                :is-required="data.solicitud.tipo_convocatoria.datos_estudios"
              />
            </b-card>
          </b-col>
          <b-col>
            <b-card>
              <direccion
                :id="data.id"
                :data="data.direccion"
                :is-required="data.solicitud.tipo_convocatoria.datos_direccion"
              />
            </b-card>
          </b-col>
          <b-col>
            <b-card>
              <direccion-notificaciones
                :id="data.id"
                :data="data.domicilionotificacion"
                :is-required="data.solicitud.tipo_convocatoria.datos_direccion_notificacion"
              />
            </b-card>
          </b-col>
          <b-col
            cols="12"
          >
            <b-card>
              <uniforme
                :id="data.id"
                :data="data.uniforme"
                :is-required="data.solicitud.tipo_convocatoria.datos_uniforme"
              />
            </b-card>
          </b-col>
          <b-col cols="12">
            <documentos-acciones
              :id="data.id"
              :data-documents="listDocuments"
              :data-actions="dataAcciones"
              :documentos-digitales="data.solicitud.tipo_convocatoria.documentos_digitales"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BBadge,
  BCard,
  BCol,
  BRow,
} from 'bootstrap-vue'

import moment from 'moment'

import TituloSection from './components/components/TituloSeccion.vue'
import Empleado from './components/Empleado.vue'
import DatosPersonales from './components/DatosPersonales.vue'
import Contacto from './components/Contacto.vue'
import Estudios from './components/Estudios.vue'
import Direccion from './components/Direccion.vue'
import DireccionNotificaciones from './components/DireccionNotificaciones.vue'
import Uniforme from './components/Uniforme.vue'
import DocumentosAcciones from './components/DocsActions.vue'

export default {
  components: {
    BBadge,
    BCard,
    BCol,
    BRow,
    TituloSection,
    Empleado,
    DatosPersonales,
    Contacto,
    Estudios,
    Direccion,
    DireccionNotificaciones,
    Uniforme,
    DocumentosAcciones,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    listDocuments: {
      type: Array,
      required: true,
    },
    mode: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    fullName() {
      const preb = this.data
      return `${preb.nombre} ${preb.apellido_paterno} ${preb.apellido_materno}`
    },
    registerDate() {
      return moment(this.data.fecha_registro).format('YYYY-MM-DD')
    },
    statusVariant() {
      const statusColor = {
        1: 'primary',
        2: 'success',
        3: 'danger',
        // 1: 'light-primary', 2: 'light-success', 3: 'light-danger',
      }
      return status => statusColor[status]
    },
    statusVariantDetalles() {
      const statusColor = {
        1: 'primary',
        2: 'success',
        3: 'danger',
      }
      return status => statusColor[status]
    },
    statusVariantIcon() {
      const statusColor = {
        1: 'ClockIcon',
        2: 'CheckCircleIcon',
        3: 'XCircleIcon',
      }
      return status => statusColor[status]
    },
    experienciaVariant() {
      const experienciaColor = { 1: 'danger', 2: 'success' }
      return experiencia => experienciaColor[experiencia]
    },
    dataAcciones() {
      const preb = this.data
      return {
        id: preb.id,
        folio: preb.solicitud.folio,
        curp: preb.curp,
        detalles: preb.solicitud.detalles,
        estatus_solicitud: preb.solicitud.estatus_solicitud.id,
        estatus_descripcion: preb.solicitud.estatus_solicitud.descripcion,
        tipo_convocatoria: preb.solicitud.tipo_convocatoria.id,
        convocatoria_descripcion: preb.solicitud.tipo_convocatoria.descripcion,
        user: {
          correo_electronico: preb.contacto.correo_electronico,
          nombre_completo: this.fullName,
        },
      }
    },
  },
}
</script>

<style>

</style>
